import { useMemo } from "react";
import { useSaleCompStore } from "..";
import ISaleComp from "../interfaces/ISaleComp";
import useSaleCompsWithFocusArea from "./useSaleCompsWithFocusArea";
import useSaleCompsWithGlobalFilters from "./useSaleCompsWithGlobalFilters";

export default function (): ISaleComp[] {
    const saleCompStore = useSaleCompStore();
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(saleCompStore.saleComps));

    return useMemo(() => {
        return saleCompStore.editedSaleCompId ? saleComps.filter((sc) => sc.id !== saleCompStore.editedSaleCompId) : saleComps;
    }, [saleComps, saleCompStore.editedSaleCompId]);
}
